import { useEffect, useState } from 'react';
import { InvoiceService } from '../../../services/invoice/invoiceService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage corporations fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de empresas.
----------------------------------------------------------------------------------------*/

const useInvoiceCorporations = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchInvoiceCorporations = async () => {
        try {
            const service = new InvoiceService();
            const response = await service.getInvoiceCorporations(filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching Invoice corporations:', error);
        }
    };

    useEffect(() => {
        fetchInvoiceCorporations();
    }, [filters]);

    const updateInvoiceCorporationsHookFilters = (newFilters: any) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    };

    const getInvoiceCorporationsList = () => {
        return data;
    };

    return { fetchInvoiceCorporations, getInvoiceCorporationsList, updateInvoiceCorporationsHookFilters };
}

export default useInvoiceCorporations;